<script lang="ts">
    import Main            from "./Main.svelte";
	import Profile         from "./Profile.svelte";
	import SupportActivity from "./SupportActivity.svelte";
	import ProjectResult   from "./ProjectResult.svelte";
	import Footer          from "./Footer.svelte";

	export let amountSupporter;
	export let amountDonatedMoney;
  export let resultDate;
</script>

<main>
    <Main/>
	<Profile/>
    <SupportActivity/>
	<ProjectResult amountSupporter={amountSupporter} amountDonatedMoney={amountDonatedMoney} resultDate={resultDate}/>
	<Footer/>
</main>

<style>
	main {
		text-align: center;
	}
</style>